import React from 'react';
import { Handle, Position } from 'reactflow';
import { 
  Box,
  Typography
} from '@mui/material';

export const SessionNumberNode = ({ data, selected, id }) => {
  return (
    <div className="react-flow__node-default" style={{ minWidth: 250, minHeight: 120 }}>
      <Handle
        type="target"
        position={Position.Left}
        style={{ 
          left: 0,
          top: 24,
          transform: 'translateY(-50%)'
        }}
      />
      
      <div className="condition-label">
        <Typography variant="body2">Session Number</Typography>
      </div>

      {/* Выходы для номеров сессий */}
      <Handle
        type="source"
        position={Position.Right}
        id="2"
        style={{
          right: 0,
          top: 24,
          transform: 'translateY(-50%)'
        }}
      />
      <Box sx={{ 
        position: 'absolute',
        right: 12,
        top: 24,
        transform: 'translateY(-50%)',
        pointerEvents: 'none'
      }}>
        <Typography variant="caption" color="textSecondary">
          Session 2
        </Typography>
      </Box>

      <Handle
        type="source"
        position={Position.Right}
        id="3"
        style={{
          right: 0,
          top: 44,
          transform: 'translateY(-50%)'
        }}
      />
      <Box sx={{ 
        position: 'absolute',
        right: 12,
        top: 44,
        transform: 'translateY(-50%)',
        pointerEvents: 'none'
      }}>
        <Typography variant="caption" color="textSecondary">
          Session 3
        </Typography>
      </Box>

      <Handle
        type="source"
        position={Position.Right}
        id="4"
        style={{
          right: 0,
          top: 64,
          transform: 'translateY(-50%)'
        }}
      />
      <Box sx={{ 
        position: 'absolute',
        right: 12,
        top: 64,
        transform: 'translateY(-50%)',
        pointerEvents: 'none'
      }}>
        <Typography variant="caption" color="textSecondary">
          Session 4
        </Typography>
      </Box>

      <Handle
        type="source"
        position={Position.Right}
        id="5"
        style={{
          right: 0,
          top: 84,
          transform: 'translateY(-50%)'
        }}
      />
      <Box sx={{ 
        position: 'absolute',
        right: 12,
        top: 84,
        transform: 'translateY(-50%)',
        pointerEvents: 'none'
      }}>
        <Typography variant="caption" color="textSecondary">
          Session 5
        </Typography>
      </Box>

      <Handle
        type="source"
        position={Position.Right}
        id="more"
        style={{
          right: 0,
          top: 104,
          transform: 'translateY(-50%)'
        }}
      />
      <Box sx={{ 
        position: 'absolute',
        right: 12,
        top: 104,
        transform: 'translateY(-50%)',
        pointerEvents: 'none'
      }}>
        <Typography variant="caption" color="textSecondary">
          More
        </Typography>
      </Box>
    </div>
  );
}; 